import useUser from "@saleor/hooks/useUser";
import Moment from "moment";

export function removeBase64Name(name: string | undefined, params: string[]) {
  try {
    const decodes = [];
    const encodes = [];

    params.forEach(param => {
      decodes.push(atob(param).replace(name, ""));
    });
    decodes.forEach(decode => {
      encodes.push(btoa(decode));
    });

    return encodes;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e.message);
  }
}

export function convertBase64(name: string | undefined, params: string[]) {
  const decodes = [];

  params.forEach(param => {
    decodes.push(atob(param).replace(name, ""));
  });

  return decodes;
}

export function ageCalculator(birthday) {
  const today = new Date();
  const birthDate = new Date(birthday);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

export function formatCurrencyData(data: number | null | undefined) {
  if (!data) {
    return Number(0?.toFixed(2));
  } else if (typeof data === "number") {
    return Number(data?.toFixed(2));
  }

  return data;
}

export function formatDateToFinanceDate(data: string | null | undefined) {
  const date = new Date(Date.parse(data));
  const day = date.getDate();
  const month = date.getMonth() + 1; // getMonth() starts with index 0
  const year = date.getFullYear();

  if (data) {
    return Moment(`${year}-${month}-${day} 17:00:00`).format(
      "YYYY-MM-DD HH:mm:ss"
    );
  }

  return "";
}

export function formatTextData(
  data: string | null | undefined,
  textFormat?: TextFormats
) {
  const newString =
    data.includes(",") && !data?.match(/^".*?"$/) ? `"${data}"` : data;

  if (textFormat === "UPC") {
    return newString.toUpperCase();
  } else if (textFormat === "LWC") {
    return newString.toLowerCase();
  } else {
    return newString;
  }
}
export type TextFormats = "UPC" | "LWC";

export function getUserFullName() {
  const firstName = useUser().user.firstName;
  const lastName = useUser().user.lastName;
  const data = firstName.concat(lastName);

  return formatTextData(data, "UPC");
}

export function getCurrentTimestamp(format: string = "YYYYMMDDHHmmss") {
  return Moment(new Date()).format(format);
}

export function statusFormatter(status) {
  let result;
  if (status === "INA") {
    result = "Inactive";
  } else if (status === "ACT") {
    result = "Active";
  } else if (status === "DEL") {
    result = "Deleted";
  } else if (status === "RVW") {
    result = "Reviewed";
  } else if (status === "DCL") {
    result = "Declined";
  }
  return result;
}

export function InvalidThreeMonth(dateFrom, dateTo) {
  const valid3MonthsDate = Moment(
    new Date(dateFrom).setMonth(new Date(dateFrom).getMonth() + 3)
  ).format("YYYY-MM-DD");

  const checkInvalidDateTo = Moment(dateTo).format("YYYY-MM-DD");

  // check if end date is invalid to 3 months rule
  if (checkInvalidDateTo > valid3MonthsDate) {
    return true;
  }

  return false;
}

export const formatDate = (date: string, format: string = "MM/DD/YYYY") =>
  Moment.tz(new Date(date), "Asia/Manila").format(format);
